import { render, staticRenderFns } from "./DetailRegistration.vue?vue&type=template&id=1906b8bc&scoped=true"
import script from "./DetailRegistration.vue?vue&type=script&lang=js"
export * from "./DetailRegistration.vue?vue&type=script&lang=js"
import style0 from "./DetailRegistration.vue?vue&type=style&index=0&id=1906b8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1906b8bc",
  null
  
)

export default component.exports